module.exports = __webpack_public_path__ + "static/media/sleepyDragonFrame3.26bbf7ab.png";